"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeServiceConfig = mergeServiceConfig;
exports.getSettings = getSettings;

var _merge = _interopRequireDefault(require("lodash/merge"));

var _servicesCore = require("@makerdao/services-core");

function mergeServiceConfig(role, sink, source, resolver) {
  sink = (0, _servicesCore.standardizeConfig)(role, sink, resolver);
  source = (0, _servicesCore.standardizeConfig)(role, source);
  if (sink[0] === false || source[0] === false) return source;
  return [typeof source[0] != 'boolean' ? source[0] : sink[0], (0, _merge["default"])({}, sink[1], source[1])];
}

function getSettings(config) {
  if (config instanceof Array) return config[1];
  return config;
}